import { Drawer, Hidden, makeStyles, useTheme } from "@material-ui/core";
import React from "react";
import {
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";

import GroupIcon from "@material-ui/icons/Group";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import QueueIcon from "@material-ui/icons/Queue";
import HomeIcon from "@material-ui/icons/Home";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  logoContainer: {
    backgroundColor: theme.palette.primary.main,
    boxShadow:
      "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  logo: {
    width: "80%",
  },
}));

const Navbar = ({ handleDrawerToggle, container }: any) => {
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const location = useLocation();

  const navItems = [
    {
      goup_name: "Home",
      menus: [
        {
          name: "Home",
          link: "/",
          icon: <HomeIcon />,
        },
      ],
    },
  
    {
      goup_name: "User",
      menus: [
        {
          name: "User List",
          link: "/user-list",
          icon: <GroupIcon />,
        },
        {
          name: "Create user",
          link: "/user-create",
          icon: <PersonAddIcon />,
        },
      ],
    },
    {
      goup_name: "Project",
      menus: [
        {
          name: "Project List",
          link: "/project-list",
          icon: <AccountTreeIcon />,
        },
        {
          name: "Create Project",
          link: "/project-create",
          icon: <QueueIcon />,
        },
      ],
    },
    {
      goup_name: "Home",
      menus: [
        {
          name: "MRX User List",
          link: "/mrx-user-list",
          icon: <GroupIcon />,
        },
      ],
    },
  ];
  const drawer = (
    <div>
      <div className={classes.toolbar + " " + classes.logoContainer}>
        <img src="https://teambdf.org/img/Logo.png" className={classes.logo} />
      </div>
      {navItems.map((menuGroup,key) => {
        return (
          <div key={key}>
            <Divider />
            <List>
              {menuGroup.menus.map((item, index) => (
                <ListItem button key={index} component={Link} to={item.link}>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText
                    primary={item.name}
                    style={{
                      color: location.pathname == item.link ? "#ff6f00" : "",
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </div>
        );
      })}
 
    </div>
  );

  return (
    <nav className={classes.drawer} aria-label="mailbox folders">
      {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
      <Hidden smUp implementation="css">
        <Drawer
          container={container}
          variant="temporary"
          anchor={theme.direction === "rtl" ? "right" : "left"}
          open={mobileOpen}
          onClose={handleDrawerToggle}
          classes={{
            paper: classes.drawerPaper,
          }}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          {drawer}
        </Drawer>
      </Hidden>
      <Hidden xsDown implementation="css">
        <Drawer
          classes={{
            paper: classes.drawerPaper,
          }}
          variant="permanent"
          open
        >
          {drawer}
        </Drawer>
      </Hidden>
    </nav>
  );
};

export { Navbar };
